var _defs, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1121({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:square;stroke-linejoin:round;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "2 10.72 2 5.19 13.01 5.19 15 4.19 1 4.19 1 11.23 2 10.72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1121);
export default __webpack_public_path__ + "static/media/Symbolpack_1_121.2af7ad80dbbf1ada8aa1107b1c7a077b.svg";
export { ForwardRef as ReactComponent };